import { APIUrl,FileManagerUrl } from "../envConfig";

export const API_URL = APIUrl;

export const FILE_MANAGER_API_URL = FileManagerUrl;

export const API_AUTORIZATION_USERNAME = process.env.REACT_APP_API_AUTORIZATION_USERNAME;

export const API_AUTORIZATION_PASSWORD = process.env.REACT_APP_API_AUTORIZATION_PASSWORD;

export const API_GRANT_TYPE = process.env.REACT_APP_API_GRANT_TYPE; 

export const API_STATUS_FAIL = 400;

export const API_STATUS_SUCCESS = 200;

export const API_STATUS_WARNING = 199;

export const API_STATUS_NOT_FOUNT = 404;

export const LEAD_WINDOW_ID = 'f46ebbd7-f54f-4d7a-b98a-d0051ce00112';

export const SUCCESS_MSG = 'SUCCESS_MESSAGE';

export const FAIL_MSG = 'FAIL_MESSAGE';

export const WARN_MSG = 'WARN_MESSAGE';

export const INFO_MSG = 'INFO_MESSAGE';

export const STRING_ARRAY = [
  'String'
];

export const NUMBER_ARRAY = [
  'BigDecimal',
  'Integer',
  'Long'
];

export const WITHOUT_DECIMAL = [
  'BigDecimal',
  'Integer',
  'Long'
];

export const EXCEED_MAIL_COUNT = 10;

export const EXCEED_REPORT_MAIL_COUNT = 100;

export const LOOKUP_FIELDS = ['Lookup','MultiLookup','MasterWindow','MasterDetailWindow','Subform'];

export const REPORT_TABULAR = 0;

export const REPORT_SUMMARY = 1;

export const REPORT_MATRIX = 2;

export const REPORT_CARD = 3;

export const AVAILABLE_AGGREGATE = ['SUM','AVG','MAX','MIN'];

export const EMAIL_WINDOW_ID = "02c23beb-b453-4b02-8d69-e23f06c2c509";

export const ACTION_INITIATED_BY = [
  {
    text: 'BROWSER',
    label: 'BROWSER',
    id: 'BROWSER',
   value:'BROWSER'
  },{
    text: 'MOBILE',
    label: 'MOBILE',
    id: 'MOBILE',
   value:'MOBILE'
  },{
    text: 'API',
    label: 'API',
    id: 'API',
   value:'API'
  }];

export const ACTION_TYPE = [
  {
    text: 'BUTTON_ACTION',
    label: 'BUTTON_ACTION',
    id: 'BUTTON_ACTION',
   value:'BUTTON_ACTION'
  },{
    text: 'CODE_ACTION',
    label: 'CODE_ACTION',
    id: 'CODE_ACTION',
   value:'CODE_ACTION'
  },{
    text: 'EMAIL_ACTION',
    label: 'EMAIL_ACTION',
    id: 'EMAIL_ACTION',
   value:'EMAIL_ACTION'
  },{
    text: 'FILE_ACTION',
    label: 'FILE_ACTION',
    id: 'FILE_ACTION',
   value:'FILE_ACTION'
  },{
    text: 'DATA_SHARING_ACTION',
    label: 'DATA_SHARING_ACTION',
    id: 'DATA_SHARING_ACTION',
   value:'DATA_SHARING_ACTION'
  },{
    text: 'WORKFLOW_ACTION',
    label: 'WORKFLOW_ACTION',
    id: 'WORKFLOW_ACTION',
   value:'WORKFLOW_ACTION'
  }];

export const FORMULA_FIELD_NON_DEISPLY_FIELD = [
  "TextArea",
  "Barcode",
  "ImageUpload",
  "FileUpload",
  "Reminder",
  "Blank"
]

export const LOOKUP_API_FIELD_ID  = {
  "02c23beb-b453-4b02-8d69-e23f06c2c510": "organizations/organization-list/",
  "02c23beb-b453-4b02-8d69-e23f06c2c508": "users/fetch-users/",
  "02c23beb-b453-4b02-8d69-e23f06c2c507": "notes/window/{WINDOW_ID}",
  "02c23beb-b453-4b02-8d69-e23f06c2c509": "email/message/search?messagePlaceholder=OUTBOX&emailConfigIds={EMAIL_CONFIG_ID}",
  "02c23beb-b453-4b02-8d69-e23f06c2c511": "users/fetch-users/",
  "02c23beb-b453-4b02-8d69-e23f06c2c512": "profiles/view/",
  "02c23beb-b453-4b02-8d69-e23f06c2c521": "rates/sheets/list/",
  "02c23beb-b453-4b02-8d69-123456789101": "windows/list/"
}

export const USERS_WINDOW_ID = ["02c23beb-b453-4b02-8d69-e23f06c2c508","02c23beb-b453-4b02-8d69-e23f06c2c511"];

export const RATE_SHEET_WINDOW_ID = "02c23beb-b453-4b02-8d69-e23f06c2c521";

export const ORGANIZATION_WINDOW_ID = "02c23beb-b453-4b02-8d69-e23f06c2c510";

export const PROFILE_WINDOW_ID = "02c23beb-b453-4b02-8d69-e23f06c2c512";

export const NOTES_WINDOW_ID = "02c23beb-b453-4b02-8d69-e23f06c2c507";

export const USERS_WINDOW_FIELD_ID = "02c23beb-b453-4b02-8d69-e23f06c2c508";

export const CUSTOM_WINDOW_ID = "02c23beb-b453-4b02-8d69-123456789101";

export const DECIMAL_FIELD_EXCLUDE_FILTERS = ["is empty","is not empty"];

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const NUMBER_FIELDS = ["currency", "decimal", "longnumber", "number", "percentage"];

export const VARIABLE_CONSTANT_TYPE = ["Array", "Object", "Error", "Messages", "List"];

export const SEE_ALL = 'See more';

export const SEE_LESS = 'See Less';

export const SUBFORM = 'subform';

export const DOUBLE = 'double';

export const SINGLE = 'single';

export const TABLE = 'table';

export const MANDATORY_ERROR_MESSAGE='please fill the mandatory field(s)';

export const MULTI_LEVEL_FIELD_TYPE = ["array", "object", "error", "messages"];

// export const REDIRECT_URLS = {
//   EDIT: "/layouts/${windowName}/${windowId}/edit/${layoutId}/${dataId}",
//   DETAIL: "/layouts/${windowName}/${windowId}/detailView/${layoutId}/${dataId}",
//   LIST: "/layouts/${windowName}/${windowId}/list/${layoutId}"
// }
export const REDIRECT_URLS = {
  EDIT: '/layouts/S$S{windowName}/S$S{windowId}/edit/S$S{layoutId}/S$S{dataId}'.replace(/S\$S/g, '$'),
  DETAIL: '/layouts/S$S{windowName}/S$S{windowId}/detailView/S$S{layoutId}/S$S{dataId}'.replace(/S\$S/g, '$'),
  LIST: '/layouts/S$S{windowName}/S$S{windowId}/list/S$S{layoutId}'.replace(/S\$S/g, '$'),
};

export const ADDITIONAL_LAYOUT_FIELDS = ["Notes","Tag","PickList","MultiSelect"];

export const NUMBER_FIELD = [
  'Number',
  'LongNumber',
  'Currency',
  'AutoNumber',
  'Decimal',
  'Percentage'
];


export const CRM_MODULE_ID = '91f6a110-7ce8-4911-9871-48146aa4aa76';
export const SHIPPING_MODULE_ID = 'e8d1f411-8a0c-4f88-952f-cba893db8d4c';

export const LAYOUT_NOT_ACTIVE = "Access denied for this layout please contact admin."



export const GRID_VIEW_TYPES = {
  LIST :"LIST",        
  KANBAN :"KANBAN",
  CALENDAR : "CALENDAR",
  SPLIT :"SPLIT"
}